// Local development
// export const BACK_URI = "http://localhost:5001/api";
// export const CLIENT_URL = "http://localhost:3000/";
// export const DASH_URI = "http://localhost:5001/";
// export const ENVIRONMENT = "local";

// // Production
export const BACK_URI = "https://clean.arktastic.com/api";
export const CLIENT_URL = "https://www.arktastic.com/";
export const DASH_URI = "https://clean.arktastic.com/";
export const ENVIRONMENT = "live";
